import type { HealthMapEdge, HealthMapNode } from "../../shared/types";

export const mockHealthMapNodes: HealthMapNode[] = [
  {
    id: "node-dashboard",
    label: "Static Web App Dashboard",
    kind: "dashboard",
    status: "SUCCEEDED",
    severity: "LOW",
    sourceType: "PLATFORM",
    x: 78,
    y: 52,
    owner: "Data Platform",
    subtitle: "Dashboard",
    detail: "React dashboard running in mock mode."
  },
  {
    id: "node-functions",
    label: "Azure Functions API",
    kind: "api",
    status: "RUNNING",
    severity: "MEDIUM",
    sourceType: "PLATFORM",
    x: 38,
    y: 50,
    owner: "Platform Engineering",
    subtitle: "API",
    detail: "Mock API endpoints normalize dashboard, job, run, event, and webhook data."
  },
  {
    id: "node-sql",
    label: "Azure SQL DB",
    kind: "database",
    status: "UNKNOWN",
    severity: "MEDIUM",
    sourceType: "PLATFORM",
    x: 45,
    y: 78,
    owner: "Data Platform",
    subtitle: "Database",
    detail: "Future normalized store for dashboard state. Not connected in Phase 1."
  },
  {
    id: "node-adls",
    label: "ADLS Gen2",
    kind: "storage",
    status: "UNKNOWN",
    severity: "MEDIUM",
    sourceType: "PLATFORM",
    x: 22,
    y: 76,
    owner: "Data Platform",
    subtitle: "Storage",
    detail: "Future raw payload and troubleshooting log store. Not connected in Phase 1."
  },
  {
    id: "node-synapse",
    label: "Azure Synapse Workspace",
    kind: "workspace",
    status: "FAILED",
    severity: "CRITICAL",
    sourceType: "SYNAPSE",
    x: 18,
    y: 27,
    owner: "Data Platform",
    subtitle: "Workspace",
    detail: "Mock Synapse workspace with healthy, failed, late, missing, and long-running pipelines."
  },
  {
    id: "node-synapse-pipelines",
    label: "Synapse Pipelines",
    kind: "pipeline",
    status: "LONG_RUNNING",
    severity: "CRITICAL",
    sourceType: "SYNAPSE",
    x: 37,
    y: 24,
    owner: "Data Platform",
    subtitle: "Pipeline fleet",
    detail: "Pipeline fleet includes active incidents for finance close and risk scoring."
  },
  {
    id: "node-acr-tasks",
    label: "ACR Tasks",
    kind: "task",
    status: "FAILED",
    severity: "HIGH",
    sourceType: "ACR",
    x: 33,
    y: 61,
    owner: "Security Engineering",
    subtitle: "Task",
    detail: "One successful image build and one failed vulnerability scan."
  },
  {
    id: "node-monitor",
    label: "Azure Monitor Alerts",
    kind: "alert",
    status: "LONG_RUNNING",
    severity: "CRITICAL",
    sourceType: "AZURE_MONITOR",
    x: 59,
    y: 25,
    owner: "SRE",
    subtitle: "Alert",
    detail: "Mock alert event for long-running Synapse risk scoring batch."
  }
];

export const mockHealthMapEdges: HealthMapEdge[] = [
  {
    id: "edge-dashboard-functions",
    source: "node-dashboard",
    target: "node-functions",
    label: "queries",
    status: "RUNNING",
    relationshipType: "queries"
  },
  {
    id: "edge-functions-sql",
    source: "node-functions",
    target: "node-sql",
    label: "future normalized state",
    status: "UNKNOWN",
    relationshipType: "serving_reads_writes"
  },
  {
    id: "edge-functions-adls",
    source: "node-functions",
    target: "node-adls",
    label: "future raw payload writes",
    status: "UNKNOWN",
    relationshipType: "writes_raw_payload"
  },
  {
    id: "edge-synapse-pipelines",
    source: "node-synapse",
    target: "node-synapse-pipelines",
    label: "runs",
    status: "LONG_RUNNING",
    relationshipType: "runs"
  },
  {
    id: "edge-synapse-functions",
    source: "node-synapse-pipelines",
    target: "node-functions",
    label: "polls",
    status: "RUNNING",
    relationshipType: "depends_on"
  },
  {
    id: "edge-acr-tasks",
    source: "node-functions",
    target: "node-acr-tasks",
    label: "queries",
    status: "FAILED",
    relationshipType: "queries"
  },
  {
    id: "edge-acr-functions",
    source: "node-acr-tasks",
    target: "node-functions",
    label: "webhooks",
    status: "FAILED",
    relationshipType: "alert"
  },
  {
    id: "edge-monitor-functions",
    source: "node-monitor",
    target: "node-functions",
    label: "alerts",
    status: "LONG_RUNNING",
    relationshipType: "alert"
  }
];
